module.exports = __webpack_public_path__ + "img/img_7.97184de5.svg";